module.exports = __webpack_public_path__ + "static/img/21020E_1_C_20210503_fit.dac1b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/21020E_1_C_20210503_fit.png
// module id = k4b2
// module chunks = 0